import { Box } from '@mui/material';
import logo from '../static/logo.png';

const PlaceholderThumbnail = () => {
  return (
    <Box
      width="100px"
      height="60px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="8px"
      sx={{
        background: '#222',
        color: 'white',
        textAlign: 'center',
        border: '1px solid #444',
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{
          width: '20px',
          height: '30px',
        }}
      />
      {/* <Typography fontSize="14px" fontWeight="bold">
        No thumbnail available
      </Typography> */}
    </Box>
  );
};

export default PlaceholderThumbnail;
